<script>
  import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner
  } from "sveltestrap";
  export let open;
  export let toggle;
  export let data;
  let deleting = false;

  async function deleteTimecard() {
    const delete_data = {
      weekStart: data.weekStart,
      staff: data.staff,
      activityId: data.activityid,
      deliverableId: data.del,
      timesheetId: data.timesheetId,
    };
    const res = await fetch("/timesheetapi/deletetasks", {
      method: "POST",
      headers: {
        "Content-type": "application/json"
      },
      body: JSON.stringify(delete_data)
    });
    const json = await res.status;
    open = true;
    if (json === 200) {
      document.getElementById("btn-search").click();
    }
  }

  function handleDelete() {
    deleting = true;
    deleteTimecard();
  }

  function handleCancel() {
    toggle();
  }
</script>

<style>

</style>

<Modal isOpen={open} {toggle} transition="fade">
  <ModalHeader {toggle}>Warning</ModalHeader>
  <ModalBody>Are you sure you want to delete this Timesheet Card?</ModalBody>
  <ModalFooter>
    {#if deleting}
      <Button
        color="primary"
        style="cursor: not-allowed; opacity: 0.5"
        disabled
        on:click={handleDelete}>
        <Spinner size="sm" />
        Deleting
      </Button>
    {:else}
      <Button color="primary" on:click={handleDelete}>Delete</Button>
    {/if}
    <Button color="secondary" on:click={handleCancel}>Cancel</Button>
  </ModalFooter>
</Modal>
